import { MEDIA } from "@/data/media";

// Real Kensmarc Electric emblem (fist + horizontal bolt) from Marcos's logo.
// `horizontal`: emblem + name plate for the header. `stacked`: full lockup.
export const Logo = ({ className = "", showText = true, size = "default", variant = "horizontal" }) => {
  if (variant === "stacked") {
    return (
      <img
        src={MEDIA.logoStacked}
        alt="Kensmarc Electric"
        className={`w-auto ${size === "sm" ? "h-20" : "h-28"} ${className}`}
        data-testid="site-logo"
      />
    );
  }
  const mark = size === "sm" ? "h-8" : "h-9 xl:h-8 2xl:h-10";
  const text = size === "sm" ? "text-sm" : "text-sm 2xl:text-base";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="site-logo">
      <img src={MEDIA.logo} alt="Kensmarc Electric emblem — fist holding a lightning bolt" className={`${mark} w-auto`} />
      {showText && (
        <span
          className={`whitespace-nowrap rounded-[5px] border border-white/10 bg-[#2c2c31] px-2 py-1 font-display ${text} font-extrabold uppercase leading-none tracking-wide text-white`}
        >
          Kensmarc Electric
        </span>
      )}
    </span>
  );
};
